import { Paper } from '@mui/material';
import axios from 'axios';
import AgGrid from 'components/AgGrid/AgGrid';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import ClipLoader from 'react-spinners/ClipLoader';
import MyButton from '../../components/Layout/MyButton';
import TopBar from '../../components/Layout/TopBar';
import { logError } from '../../components/Utils/FormatData';
import { URL_API } from '../../utils/globalConfig';
import useAuthz from '../../hooks/useAuthz';
import { PARAMETER, PARAMETER_VALUE } from '../../constants/enum';
import ActionsParameterRenderer from '../../components/AgGrid/ActionsParameterRenderer';

const Parametrage = (props) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [listParameters, setParameters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [authz, user, profil] = useAuthz();
  const [needReload, setNeedReload] = useState(false);

  const translateKey = (key) => {
    switch (key) {
      case PARAMETER.LEGAL_NOTICE:
        return 'Mentions légales';
      case PARAMETER.PARTICULAR_NOTICE:
        return 'Conditions particulières'
      case PARAMETER.ALERT_CHANGE:
        return 'Changement sur un dossier';
      default:
        return key;
    }
  };

  const columnDefs = [
    {
      headerName: '',
      field: '',
      flex: 1,
      minWidth: 75,
      sortable: false,
      cellRenderer: 'actionParameterRenderer',
    },
    {
      headerName: 'Id',
      field: 'id',
      flex: 1,
      minWidth: 75,
      maxWidth: 100,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Libellé',
      field: 'key',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
      valueFormatter: (params) => {
        return translateKey(params.data.key);
      },
    }, {
      headerName: 'Description',
      field: 'description',
      flex: 5,
      minWidth: 150,
      maxWidth: 400,
      sortable: true,
      filter: 'agTextColumnFilter',
      wrapText: true,
      autoHeight: true,
      cellStyle: { 'line-height': '2 !important', 'word-break': 'break-word' },
    },
    {
      headerName: `Valeur`,
      field: 'value',
      flex: 5,
      minWidth: 150,
      maxWidth: 900,
      sortable: true,
      filter: 'agTextColumnFilter',
      wrapText: true,
      autoHeight: true,
      valueFormatter: (params) => {
        if (params.data.key === PARAMETER.LEGAL_NOTICE || params.data.key === PARAMETER.PARTICULAR_NOTICE) {
          return params.data.value.substring(0, 100) + '...';
        }

        if (params.data.key === PARAMETER.NAT_CONVOI) {
          return JSON.parse(params.data.value).join(', ');
        }

        if (params.data.key === PARAMETER.ALERT_CHANGE) {
          let value = '';
          JSON.parse(params.data.value).forEach((element) => {
            switch (element) {
              case 'engage':
                value += PARAMETER_VALUE.ALERT_CHANGE.ENGAGE + ', ';
                break;
              case 'planning_filled':
                value += PARAMETER_VALUE.ALERT_CHANGE.PLANNING_FILLED + ', ';
                break;
              case 'devis_validated':
                value += PARAMETER_VALUE.ALERT_CHANGE.DEVIS_VALIDATED + ', ';
                break;
              case 'document_uploaded':
                value += PARAMETER_VALUE.ALERT_CHANGE.DOCUMENT_UPLOADED + ', ';
                break;
              default:
                value += element + ', ';
                break;
            }
          });
          return value;
        }

        return params.data.value;
      },
      cellStyle: { 'line-height': '2 !important', 'word-break': 'break-word' },
    },
  ];

  const agGridOptions = {
    suppressCellSelection: true, suppressHorizontalScroll: false, animateRows: true,
  };
  const frameworkComponents = {
    actionParameterRenderer: ActionsParameterRenderer,
  };

  useEffect(() => {
    if (profil.profil === 1) {
      document.title = 'TE - Paramétrage';
      getParameters();
    } else {
      alert.error('Vous n\'êtes pas autorisé à accéder au paramétrage');
      navigate('/');
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (needReload) {
      getParameters();
      setNeedReload(false);
    }
  }, [needReload]);

  const getParameters = () => {
    axios({ method: 'get', url: `${URL_API}/parameters/full-list` })
      .then((response) => {
        let parameters = response.data.filter((param) => param.key !== 'SIGNATURE_PDF');
        setParameters(parameters);
        setIsLoading(false);
      })
      .catch((err) => {
        logError(alert, err);
      });

  };

  return (<div style={{ height: '100%' }}>
    <TopBar title='Paramétrage' className='topbar-contenu' color={props.params.color}
            buttons={
              <div className='topbar-buttons'>
                <MyButton onClick={() => navigate('/panneau-administration')} icon={''} label={'Retour'} />
              </div>
            }
    />

    <div className='row' style={{ margin: 0, overflow: 'hidden' }}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75}
                  css={'display: flex; margin: 25px;justify-content: center;'} />

      {!isLoading &&
        (<Paper style={{ height: '100%', width: '100%', borderTop: '1px solid #4db4da' }}>
          <AgGrid
            key={'ag-grid-parametrage'}
            rowData={listParameters}
            columnDefs={columnDefs}
            frameworkComponents={frameworkComponents}
            rowHeight={40}
            pagination={false}
            gridOptions={agGridOptions}
            sortable={false}
          />
        </Paper>)
      }
    </div>
  </div>);
};

export default Parametrage;